import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { usePrefersReducedMotion } from "../../hooks/usePrefersReducedMotion";

const WORDS = [
  "We", "believe", "decades", "of", "experience", "shouldn\u2019t", "be", "the",
  "end", "of", "an", "entrepreneurial", "career.", "They", "should", "be", "the",
  { text: "beginning", gold: true }, "of", "the", "most", "important",
  "company", "you", "build.",
];

function Word({ progress, range, children, gold }) {
  const opacity = useTransform(progress, range, [0.18, 1]);
  return (
    <motion.span
      style={{ opacity }}
      className={`mr-[0.26em] inline-block ${gold ? "text-gold" : "text-carbon"}`}
    >
      {children}
    </motion.span>
  );
}

export default function Belief() {
  const ref = useRef(null);
  const reduced = usePrefersReducedMotion();
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start 0.85", "start 0.2"],
  });
  const total = WORDS.length;

  return (
    <section
      ref={ref}
      id="belief"
      data-testid="belief-section"
      className="relative flex min-h-[70vh] scroll-mt-24 items-center bg-bone py-24 text-carbon md:py-28"
    >
      <div className="mx-auto w-full max-w-[1000px] px-6 md:px-10">
        <p
          className="font-serif font-medium leading-[1.14] tracking-tightest"
          style={{ fontSize: "clamp(2rem, 4.6vw, 4rem)" }}
        >
          {WORDS.map((w, i) => {
            const isObj = typeof w === "object";
            const text = isObj ? w.text : w;
            const gold = isObj && w.gold;
            if (reduced) {
              return (
                <span key={i} className={`mr-[0.26em] inline-block ${gold ? "text-gold" : "text-carbon"}`}>
                  {text}
                </span>
              );
            }
            const start = (i / total) * 0.9;
            const end = start + 1 / total + 0.06;
            return (
              <Word key={i} progress={scrollYProgress} range={[start, end]} gold={gold}>
                {text}
              </Word>
            );
          })}
        </p>
      </div>
    </section>
  );
}
